module.exports = __webpack_public_path__ + "static/media/Corrientes.221819eb.svg";